// extracted by mini-css-extract-plugin
export default {"tree":"Tree-module__tree___NQBfW"};